const Component = () => import('./AcquisitionPDP');

export { Component };
